import * as $ from 'jquery';

function initHeroPopovers() {

  if ($(".hero").length > 0) {
    $( ".content.cta-container" ).wrap( "<div class='container-fluid cta-container__fluid'></div>" );
  }

  $(".hero__toptaak-close-popover").click(function (event) {
    event.preventDefault();

    $(this).closest(".hero__toptaak-popover").removeClass("hero__toptaak-popover--show-popover");
    $(this).closest(".hero__toptaak-popover").removeClass("hero__toptaak-popover--hover-show-popover");

    $(".hero__toptaak--show-popover").removeClass("hero__toptaak--show-popover");
    $(this).closest(".hero").removeClass("hero--show-popover");
    $(".hero__site-overlay").addClass("hero__site-overlay--hidden");
    return false;
  }); 

  setTimeout(function() {

    $("body").click(function () {
      if ($(event.target).closest(".hero__toptaak-popover").length == 0) {       
        $(".hero__toptaak-popover").removeClass("hero__toptaak-popover--show-popover");
        $(".hero__toptaak--show-popover").removeClass("hero__toptaak--show-popover");
        $(".hero").removeClass("hero--show-popover");
        $(".hero__site-overlay").addClass("hero__site-overlay--hidden");

        $(".hero__bedrijfzoeker-results").addClass("hidden");
      }
    });
  
  }, 500);

  $(".hero__toptaak--with-popover").click(function (event) {
    event.preventDefault();    

    if ($($(this).attr("data-toptaak")).hasClass("hero__toptaak-popover--show-popover")) {

      $(this).removeClass("hero__toptaak--show-popover");
      $($(this).attr("data-toptaak")).removeClass("hero__toptaak-popover--show-popover");
      $(this).closest(".hero").removeClass("hero--show-popover");
      $(".hero__site-overlay").addClass("hero__site-overlay--hidden");

    } else {

      $(this).closest(".hero").addClass("hero--show-popover");
      $(".hero__site-overlay").removeClass("hero__site-overlay--hidden");

      $(".hero__toptaken-list").find(".hero__toptaak--show-popover").removeClass("hero__toptaak--show-popover");
      $(".hero__toptaken-list").find(".hero__toptaak--hover-show-popover").removeClass("hero__toptaak--hover-show-popover");

      $(this).addClass("hero__toptaak--show-popover");

      $($(this).attr("data-toptaak")).addClass("hero__toptaak-popover--show-popover");

      $(".hero__toptaak-popover-inner-container").css("min-height", $(".hero__toptaken-inner-container").innerHeight() + "px");

    }

    return false;
  });

  var searchIndex : number = 1;
  let trackAjaxCalls : Array<any> = new Array<any>();

  let storeTimer : any = undefined;

  $(".hero__bedrijfzoeker-input").on("input", function (event) {
    $(".hero__bedrijfzoeker-results").empty();
    $(".hero__bedrijfzoeker-results").addClass("hero__bedrijfzoeker-results--hidden");
  });

  $(".hero__bedrijfzoeker-form .input-group-append").click(function(event) {
    event.preventDefault();
    
    $(".hero__bedrijfzoeker-form").submit();
    return false;
  });

  $("form.hero__bedrijfzoeker-form").submit(function (event) {
    event.preventDefault();

    let self : any = $("form.hero__bedrijfzoeker-form");

    var noResultsText = $(self).attr("data-no-results");
    var maxResultsText = $(self).attr("data-max-results");

    searchIndex++;

    let oldSearchIndex : number = searchIndex;

    trackAjaxCalls.map((request : any) => {
      request.abort();
    });

    trackAjaxCalls = new Array<any>();
    
    if (typeof storeTimer != "undefined") {
      clearTimeout(storeTimer);
      storeTimer = undefined;
    }
    

    storeTimer = setTimeout(function () {
    
      var url = $(self).find("input").attr("data-url");
      (<any>  window).dataLayer = (<any>  window).dataLayer || [];
      
      var caozoekTermEvent = {};
      (<any> caozoekTermEvent)["event"] = "caozoekterm";
      (<any> caozoekTermEvent)["caozoekterm"] = $(self).find("input").val();
      (<any>  window).dataLayer.push(caozoekTermEvent);

      $(".hero__bedrijfzoeker-results").empty();
      $(".hero__bedrijfzoeker-results").addClass("hero__bedrijfzoeker-results--hidden");

      var searchWords : Array<string> = (<string> $(self).find("input").val() || "").replace(/[.,\/#!$%\^&\*;:{}=''""\-_`~()]/g, " ").split(" ");
      var searchPromises : Array<any> = new Array<any>();
      var searchResults : any = {};

      if ($(self).find("input").val() == "" || searchWords.length == 0) {
        searchIndex++;

        $(".hero__bedrijfzoeker-results").html("");
        $(".hero__bedrijfzoeker-results").addClass("hero__bedrijfzoeker-results--hidden");
        return false;
      }

      // .join(" AND "),
      let request : any = $.ajax({
        url: url + searchWords.join(" "),
        dataType: 'json',
        contentType: 'application/json',
        headers: { 'api-key': '02C99D1B4823F95DC426F97F99FDB3D6' }
      }).done(function(data) {
        searchResults[0] = data;
      });

      searchPromises.push(request);
      trackAjaxCalls.push(request);

      let bedrijven : any = {};

      $.when.apply(undefined, searchPromises).then(() => {
        if (oldSearchIndex == searchIndex) {

          $(".hero__bedrijfzoeker-results").removeClass("hero__bedrijfzoeker-results--hidden");

          var results : Array<any> = new Array<any>();
          results = searchResults[0].searchResults;
                    
          var html : string = "";

          if (typeof results !== "undefined" && typeof results.length !== "undefined" && results.length > 0) {

            
            let bedrijvenCounter : number = 0;
            results.map((bedrijf: any, index : number) => {

              if (bedrijf !== null && typeof bedrijf !== "undefined" && typeof bedrijf.Document !== "undefined") {

                if (typeof bedrijven[bedrijf.Document.Bedrijfsnaam] != "undefined") {
                  bedrijven[bedrijf.Document.Bedrijfsnaam].push(bedrijf);                  
                } else {
                  bedrijven[bedrijf.Document.Bedrijfsnaam] = [bedrijf];
                  bedrijvenCounter++;
                }
                
              }
            });

            if (bedrijvenCounter >= 10) {
              html = "<span class='hero__bedrijfzoeker-max-resultaten'>" + maxResultsText + "</span>";
            }
            
            for (let bedrijfNaam in bedrijven) {
              if (bedrijven.hasOwnProperty(bedrijfNaam)) {
                let bedrijf : any = bedrijven[bedrijfNaam][0];
                let caoListHtml : string = "";
                let caos : any = [];
                
                (<any> bedrijven[bedrijfNaam]).map((cao : any, index : number) => {
                  if (caos.indexOf(cao.Document.CaoCode) < 0) {
                    caos.push(cao.Document.CaoCode);
                  
                    var bedrijfLink = "/caoredirect/" + cao.Document.CaoCode;
                    caoListHtml += "<a href='" + bedrijfLink + 
                      "' class='hero__bedrijfzoeker-bedrijf-address'><span class='icon icon-chevron'></span><span class='hero__bedrijfzoeker-bedrijf-address-link-text'>" + 
                      cao.Document.CaoNaam + "</span></a>";
                  }
                });

                html += "<span class='hero__bedrijfzoeker-bedrijf'>" +
                    "<span class='hero__bedrijfzoeker-results-company-link'>" + bedrijf.Document.Bedrijfsnaam + "</span>" +
                    caoListHtml + 
                  "</span>";
              }
            }
            
          } else {
            html  = "<span class='hero__bedrijfzoeker-geen-resultaten'>" + noResultsText + "</span>";
          }

          $(".hero__bedrijfzoeker-results").html(html);
        }
      });
    }, 500);

    return false;
  });
 

  if ($(".hero__toptaak-popover select").length > 0) {
    $(".hero__toptaak-popover select").change(function (event) {
      location.href = (<any> this).value;
    });
  }

  if ($("select.hero__sectorzoeker-select").length > 0) {
    $.ajax({
      url: $("select.hero__sectorzoeker-select").attr("data-url"),
      dataType: 'json',
      contentType: 'application/json'
    }).done(function(data) {
      var html : string = "";

      function compare(a : any, b: any) : number {
        if (a.Title.toLowerCase() < b.Title.toLowerCase())
          return -1;
        if (a.Title.toLowerCase() > b.Title.toLowerCase())
          return 1;
        return 0;
      }
            
      let sectors : Array<any> = [];
      data.map((sector : any, index : number) => {
        if (sector.Title != "") {
          if (typeof sector.Synonyms != "undefined") {
            sector.Synonyms.map((synoniem : string, index : number) => {
              let sectorSynoniem : any = {};
              sectorSynoniem.Title = synoniem;
              sectorSynoniem.Url = sector.Url;
              sectors.push(sectorSynoniem);
            });
          }

          sectors.push(sector);
        }
      });

      sectors.sort(compare);

      sectors.map((sector : any, index : number) => {
        if (sector.Title != "") {
          html += "<option value='" + sector.Url + "'>" + sector.Title + "</option>";
        }
      });

      $("select.hero__sectorzoeker-select").append(html);
      (<any> $("select.hero__sectorzoeker-select")).selectpicker('refresh');

      (<any> $("select.hero__sectorzoeker-select")).selectpicker('deselectAll');

    });
  }
}

export { initHeroPopovers };